
const API_URL = "/api/fiche_fics";
/*DOMAINE_DOM*/
export async function getCommunications(url = API_URL) {
  const res = await fetch(url);
  const data = await res.json();

  return {
    items: data["hydra:member"] || [],
    view: data["hydra:view"] || null,
    total: data["hydra:totalItems"] || 0
  };
}

export async function getDomainByID(url = API_URL, id ) {
    console.log('ddddffd',`${url}/${id}`);
    const res = await fetch(`${url}/${id}`);

    const data = await res.json();
    console.log('data',data);

    return data;
}

export async function addDomain(domain) {
    const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/ld+json" },
        body: JSON.stringify(domain),
    });
    return await res.json();
}

export async function updateDomain(id, domain) {
    const res = await fetch(`${API_URL}/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/ld+json" },
        body: JSON.stringify(domain),
    });
    return await res.json();
}

export async function deleteDomain(id) {
    return fetch(`${API_URL}/${id}`, { method: "DELETE" });
}
